export const createSelectDispatchers = (payloadKey) => ({
  selectAll: (
    dispatch, actions, name, locationList, specificLocationList, machineList,
    status = true
  ) => {
    dispatch(actions.selectAll({ [payloadKey]: name, status }));
    dispatch(actions.locationSelect(locationList));
    dispatch(actions.specificLocationSelect(specificLocationList));
    dispatch(actions.machineSelect(machineList));
    if (!status) {
      dispatch(actions.addLocations({ [payloadKey]: name, arr: [] }));
      dispatch(actions.addSpecificLocations({ [payloadKey]: name, arr: [] }));
      dispatch(actions.addMachines({ [payloadKey]: name, arr: [] }));
    }
  },

  selectLocation: (
    dispatch, actions, name, locationList, specificLocationList, machineList,
    newSelectedLocations, newSpecificLocations, newMachines
  ) => {
    dispatch(actions.locationSelect({ [payloadKey]: name, arr: locationList }));
    if (specificLocationList.length > 0) {
      dispatch(actions.specificLocationSelect({ [payloadKey]: name, arr: specificLocationList }));
    }
    dispatch(actions.machineSelect({ [payloadKey]: name, arr: machineList }));
    dispatch(actions.addLocations({ [payloadKey]: name, arr: newSelectedLocations }));
    if (newSpecificLocations !== undefined) {
      dispatch(actions.addSpecificLocations({ [payloadKey]: name, arr: newSpecificLocations }));
    }
    if (newMachines !== undefined) {
      dispatch(actions.addMachines({ [payloadKey]: name, arr: newMachines }));
    }
  },

  selectSpecificLocation: (
    dispatch, actions, name, specificLocationList, machineList,
    newSpecificLocations, newMachines
  ) => {
    dispatch(actions.specificLocationSelect({ [payloadKey]: name, arr: specificLocationList }));
    dispatch(actions.machineSelect({ [payloadKey]: name, arr: machineList }));
    dispatch(actions.addSpecificLocations({ [payloadKey]: name, arr: newSpecificLocations }));
    if (newMachines !== undefined) {
      dispatch(actions.addMachines({ [payloadKey]: name, arr: newMachines }));
    }
  },

  selectMachine: (
    dispatch, actions, name, extraOption, locationIdx, specLocationIdx, machineIdx,
    newSelectedMachine, status = true
  ) => {
    if (extraOption && actions.machineSelectWithSpecLocationAlt) {
      dispatch(
        actions.machineSelectWithSpecLocationAlt({
          [payloadKey]: name,
          locationIdx,
          specLocationIdx,
          machineIdx,
          status,
        })
      );
    } else {
      dispatch(
        actions.machineSelectAlt({
          [payloadKey]: name,
          locationIdx,
          specLocationIdx,
          machineIdx,
          status,
        })
      );
    }
    dispatch(actions.addMachines({ [payloadKey]: name, arr: newSelectedMachine }));
  },
});
